import { render, staticRenderFns } from "./QuotaBuyRecords.vue?vue&type=template&id=416e668b&scoped=true"
import script from "./QuotaBuyRecords.vue?vue&type=script&lang=js"
export * from "./QuotaBuyRecords.vue?vue&type=script&lang=js"
import style0 from "./QuotaBuyRecords.vue?vue&type=style&index=0&id=416e668b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416e668b",
  null
  
)

export default component.exports